import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Loading from '@/components/Loading.vue';
import CardSet from '@/components/CardSet.vue';
import BackButton from '@/components/BackButton.vue';
const blobsModule = namespace('blobs');
let ExpandedContent = class ExpandedContent extends Vue {
    created() {
        this.fetchExpandedContentBlobs();
    }
    get expandedContentBlobsWithLinks() {
        return this.expandedContentBlobs.map(expandedContentBlobs => ({
            ...expandedContentBlobs,
            to: `expandedContent/${expandedContentBlobs.chapterName}`
        }));
    }
};
__decorate([
    blobsModule.State
], ExpandedContent.prototype, "expandedContentBlobs", void 0);
__decorate([
    blobsModule.Action
], ExpandedContent.prototype, "fetchExpandedContentBlobs", void 0);
ExpandedContent = __decorate([
    Component({
        components: {
            Loading,
            BackButton,
            CardSet
        }
    })
], ExpandedContent);
export default ExpandedContent;
